"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePLSUrlLoggedOut = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _updatePlsQueryParams = require("./update-pls-query-params");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _utils = require("@navinc/utils");

var updatePLSUrlLoggedOut = function updatePLSUrlLoggedOut(url) {
  var _global$utag, _global$utag$data;

  var search = _utils.global.location.search;
  var queryParams = new URLSearchParams(search); // Query params deny list

  queryParams["delete"]('user_id');
  queryParams["delete"]('user_id_type'); // Use Tealium visitor ID to identify the user

  if ((_global$utag = _utils.global.utag) !== null && _global$utag !== void 0 && (_global$utag$data = _global$utag.data) !== null && _global$utag$data !== void 0 && _global$utag$data.tealium_visitor_id) {
    var _global$utag2, _global$utag2$data;

    queryParams.set('user_id', (_global$utag2 = _utils.global.utag) === null || _global$utag2 === void 0 ? void 0 : (_global$utag2$data = _global$utag2.data) === null || _global$utag2$data === void 0 ? void 0 : _global$utag2$data.tealium_visitor_id);
    queryParams.set('user_id_type', 'USER_ID_TYPE_TEALIUM_VISITOR_ID');
  }

  var allCookies = _jsCookie["default"].get();

  Object.entries(allCookies).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if ((0, _utils.isUTMParam)(key) && !queryParams.has(key)) {
      queryParams.append(key, value);
    }
  });
  return (0, _updatePlsQueryParams.updatePLSQueryParams)(url, queryParams);
};

exports.updatePLSUrlLoggedOut = updatePLSUrlLoggedOut;
//# sourceMappingURL=update-pls-url-logged-out.js.map